module.exports = __webpack_public_path__ + "static/img/RENAULT.e5f8d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/RENAULT.png
// module id = WLHb
// module chunks = 1